import { clearSStorage, setSStorageInfo } from './utils'

const isDev = process.env.NODE_ENV !== 'production'

/**
 * 转化对象到qs
 * */
export const objectToQueryString = (obj: any) => {
  if (!obj || typeof obj !== 'object') {
    return ''
  }

  const arr: string[] = []
  Object.keys(obj).forEach(key => {
    const val = obj[key]
    arr.push(`${key}=${val}`)
  })
  return arr.length ? `${arr.join('&')}` : ''
}

/**
 * 获取跳转链接
 * */
export const getUrl = (url: string, query: any = {}) => {
  const href = `/${isDev ? '' : 'flush-account/'}${url}${isDev ? '' : '.html'}`
  const qs = objectToQueryString(query)
  return `${href}#/?platform=ths&${qs}`
}

/**
 * 根据当前环境切换跳转目标地址
 * */
export default (url: string, query: any = {}) => {
  clearSStorage('lastPage')
  setSStorageInfo('lastPage', window.location.pathname)
  // console.log(getUrl(url, query))

  window.location.href = getUrl(url, query)
}

interface numberKeyObj {
  [key: number]: any
}

/**
 * 获取url参数
 * */
export function getQueryParams() {
  const url = window.location.href.replace('#/', '')
  const arr = url.split('?')
  const str = arr.length > 1 ? arr[1] : ''
  const result: numberKeyObj = {}

  if (!str) {
    return {}
  }
  return str.split('&').reduce((current, next) => {
    if (next.includes('=')) {
      const objArr: string[] = next.split('=')
      current[<any>objArr[<any>0]] = objArr[1]
    }
    return current
  }, result)
}
